export const branding = (state = "") => {
  return state;
};
